
import { ChangeEvent } from 'react'

export function IsValid(data: any): boolean {
  // 값이 null, undefined, 빈 문자열, 빈 배열, 빈 객체, 0, false 등을 체크
  if (
    data === null ||
    data === undefined ||
    (typeof data === 'string' && data.trim() === '') || // 빈 문자열
    (typeof data === 'number' && data === 0) || // 0인 숫자
    (Array.isArray(data) && data.length === 0) || // 빈 배열
    (data instanceof Map && data.size === 0) || // 빈 Map
    (typeof data === 'object' && !Array.isArray(data) && !(data instanceof Map) && Object.keys(data).length === 0) // 빈 객체
  ) {
    return false
  }

  return true
}

export function IsNull(value: any): boolean {
  if (value === '' || value === null || value === undefined || value === 0 || Number.isNaN(value)) {
    return true
  }
  return false
}

export function IsEmpty(value: any): boolean {
  if (value === '' || value === null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
    return true
  }
  return false
}

export function checkSpace(str: string) {
  if (str.search(/\s/) !== -1) {
    return true
  }
  return false
}

export function isEmptyObject(obj: any) {
  if (obj instanceof Map) {
    return obj.size === 0
  }

  if (obj instanceof Object) {
    return Object.keys(obj).length === 0
  }

  return false // Map이나 Object가 아닌 경우
}

export const GetCloseSide = (positionSide: string) => {
  if (positionSide === 'LONG') {
    return 'SELL'
  }
  return 'BUY'
}

export const updateAmount = (e: ChangeEvent<HTMLInputElement>, setAmount: (value: string) => void, decimal: number = 8) => {
  const { value } = e.target

  const regex = decimal === 0 ? new RegExp(`^\\d*$`) : new RegExp(`^\\d*(\\.\\d{0,${decimal}})?$`)

  if (regex.test(value)) {
    setAmount(value)
  }
}
